<template>
  <div id="videoReplay">
    <el-row>
      <el-col :span="2"><div class="date">日期：</div></el-col>
      <el-col :span="14">
        <input
          type="datetime-local"
          id="startTimeStamp"
          class="el-input__inner dateInp"
          placeholder="开始时间"
        />
        <span
          class="dateLine"
          style="width: 20px; text-align: center; float: left"
          >—</span
        >
        <input
          type="datetime-local"
          class="el-input__inner dateInp"
          id="endTimeStamp"
          placeholder="结束时间"
        />
      </el-col>
      <el-col :span="8">
        <el-button type="primary" icon="el-icon-video-play" @click="play"
          >播放</el-button
        >
        <el-button type="primary" icon="el-icon-video-pause" @click="stop"
          >停止</el-button
        >
      </el-col>
    </el-row>
    <div class="block">
      <span id="tipInfo" style="color: red; line-height: 30px"></span>
    </div>
    <!--视频窗口展示-->
    <div
      id="playWnd"
      class="playWnd"
      :style="{ marginLeft: marginLeft + 'px', marginTop: marginTop + 'px' }"
    ></div>
  </div>
</template>

<script>
import $ from "jquery";
window.jQuery = $;
let oWebControl;
let initCount = 0;
let pubKey = "";
let width = "900";
let height = $(window).height() / 2;
let left = "-3";
let topH = $(window).height() / 8 - 90;
let baseUrl = process.env.BASE_URL;
export default {
  props: ["reparams"],
  data() {
    return {
      //视频回放参数
      camreaParams: {
        cameraIndexCode: undefined,
        hkappKey: undefined,
        hksecret: undefined,
        hkip: undefined,
        hkport: undefined,
        hksnapDir: undefined,
        hkvideoDir: undefined,
      },
      marginLeft: "",
      marginTop: "",
    };
  },
  created() {
    this.marginLeft = left;
    this.marginTop = 20;
  },
  mounted() {
    this.getInitParam();
    this.initPlugin();
    $(window).resize(() => {
      if (oWebControl != null) {
        oWebControl.JS_Resize(width, height);
        this.setWndCover();
      }
    });

    //设置默认时间
    let endTime = this.dateFormat(new Date(), "yyyy-MM-ddT23:59");
    let startTime = this.dateFormat(new Date(), "yyyy-MM-ddT00:00");
    $("#startTimeStamp").val(startTime);
    $("#endTimeStamp").val(endTime);
  },
  beforeUnmount() {
    this.closeWindow(); //关闭插件
  },
  methods: {
    getInitParam() {
      this.camreaParams.cameraIndexCode = this.reparams.hikId;
      this.camreaParams.hkappKey = "29278714";
      this.camreaParams.hksecret = "GPdH7amwlR70yVAH7d53";
      this.camreaParams.hkip = "47.108.210.213";
      this.camreaParams.hkport = "443";
      this.camreaParams.hksnapDir = "";
      this.camreaParams.hkvideoDir = "";
    },
    initPlugin() {
      const _this = this;
      oWebControl = new WebControl({
        szPluginContainer: "playWnd", //指定容器id
        iServicePortStart: 15900, //指定起止端口号，建议使用该值
        iServicePortEnd: 15909,
        cbConnectSuccess: function () {
          // setCallbacks();
          //实例创建成功后需要启动服务
          oWebControl
            .JS_StartService("window", {
              dllPath: "./VideoPluginConnect.dll",
            })
            .then(
              function () {
                oWebControl
                  .JS_CreateWnd("playWnd", width, height)
                  .then(function () {
                    //JS_CreateWnd创建视频播放窗口，宽高可设定
                    console.log("JS_CreateWnd success");
                    _this.init(); //创建播放实例成功后初始化
                  });
              },
              function () {}
            );
        },
        cbConnectError: function () {
          console.log("cbConnectError");
          oWebControl = null;
          $("#tipInfo").html("提示：插件未启动，正在尝试启动，请稍候...");
          //$("#playWnd").html("插件未启动，正在尝试启动，请稍候...");
          WebControl.JS_WakeUp("VideoWebPlugin://"); //程序未启动时执行error函数，采用wakeup来启动程序
          initCount++;
          console.log("initCount:" + initCount);
          if (initCount < 3) {
            setTimeout(function () {
              _this.initPlugin();
            }, 2000);
          } else {
            $("#tipInfo").html(
              "提示：插件启动失败，请检查插件是否安装！" +
                '<a href="' +
                '/static/js/VideoWebPlugin.exe" download style="color:blue">下载插件</a>'
            );

            //$("#playWnd").html("插件启动失败，请检查插件是否安装！");
          }
        },
        cbConnectClose: function () {
          console.log("cbConnectClose");
          oWebControl = null;
        },
      });
    },
    init() {
      const _this = this;
      this.getPubKey(function () {
        // 请自行修改以下变量值
        let appkey = _this.camreaParams.hkappKey; //综合安防管理平台提供的appkey，必填
        let secret = _this.setEncrypt(_this.camreaParams.hksecret); //综合安防管理平台提供的secret，必填
        let ip = _this.camreaParams.hkip; //综合安防管理平台IP地址，必填
        let playMode = 1; //初始播放模式：0-预览，1-回放
        let port = 443; //综合安防管理平台端口，若启用HTTPS协议，默认443
        let snapDir = ""; //抓图存储路径
        let videoDir = ""; //紧急录像或录像剪辑存储路径
        let layout = "1x1"; //playMode指定模式的布局
        let enableHTTPS = 1; //是否启用HTTPS协议与综合安防管理平台交互，这里总是填1
        let encryptedFields = "secret"; //加密字段，默认加密领域为secret
        let showToolbar = 1; //是否显示工具栏，0-不显示，非0-显示
        let showSmart = 1; //是否显示智能信息（如配置移动侦测后画面上的线框），0-不显示，非0-显示
        let buttonIDs =
          "0,16,256,257,258,259,260,512,513,514,515,516,517,768,769"; //自定义工具条按钮
        // 请自行修改以上变量值

        oWebControl
          .JS_RequestInterface({
            funcName: "init",
            argument: JSON.stringify({
              appkey: appkey, //API网关提供的appkey
              secret: secret, //API网关提供的secret
              ip: ip, //API网关IP地址
              playMode: playMode, //播放模式（决定显示预览还是回放界面）
              port: port, //端口
              snapDir: snapDir, //抓图存储路径
              videoDir: videoDir, //紧急录像或录像剪辑存储路径
              layout: layout, //布局
              enableHTTPS: enableHTTPS, //是否启用HTTPS协议
              encryptedFields: encryptedFields, //加密字段
              showToolbar: showToolbar, //是否显示工具栏
              showSmart: showSmart, //是否显示智能信息
              buttonIDs: buttonIDs, //自定义工具条按钮
            }),
          })
          .then(function (oData) {
            oWebControl.JS_Resize(width, height); // 初始化后resize一次，规避firefox下首次显示窗口后插件窗口未与DIV窗口重合问题
          });
      });
    },
    //获取公钥, 不用改
    getPubKey(callback) {
      oWebControl
        .JS_RequestInterface({
          funcName: "getRSAPubKey",
          argument: JSON.stringify({
            keyLength: 1024,
          }),
        })
        .then(function (oData) {
          console.log(oData);
          if (oData.responseMsg.data) {
            pubKey = oData.responseMsg.data;
            callback();
          }
        });
    },
    //RSA加密, 不用改
    setEncrypt(value) {
      let encrypt = new JSEncrypt();
      encrypt.setPublicKey(pubKey);
      return encrypt.encrypt(value);
    },
    // 设置窗口裁剪，当因滚动条滚动导致窗口需要被遮住的情况下需要JS_CuttingPartWindow部分窗口
    setWndCover() {
      let iWidth = $(window).width();
      let iHeight = $(window).height();
      let oDivRect = $("#playWnd").get(0).getBoundingClientRect();

      let iCoverLeft = oDivRect.left < 0 ? Math.abs(oDivRect.left) : 0;
      let iCoverTop = oDivRect.top < 0 ? Math.abs(oDivRect.top) : 0;
      let iCoverRight =
        oDivRect.right - iWidth > 0 ? Math.round(oDivRect.right - iWidth) : 0;
      let iCoverBottom =
        oDivRect.bottom - iHeight > 0
          ? Math.round(oDivRect.bottom - iHeight)
          : 0;

      iCoverLeft = iCoverLeft > 1000 ? 1000 : iCoverLeft;
      iCoverTop = iCoverTop > 600 ? 600 : iCoverTop;
      iCoverRight = iCoverRight > 1000 ? 1000 : iCoverRight;
      iCoverBottom = iCoverBottom > 600 ? 600 : iCoverBottom;

      oWebControl.JS_RepairPartWindow(0, 0, 1001, 600); // 多1个像素点防止还原后边界缺失一个像素条
      if (iCoverLeft != 0) {
        oWebControl.JS_CuttingPartWindow(0, 0, iCoverLeft, 600);
      }
      if (iCoverTop != 0) {
        oWebControl.JS_CuttingPartWindow(0, 0, 1001, iCoverTop); // 多剪掉一个像素条，防止出现剪掉一部分窗口后出现一个像素条
      }
      if (iCoverRight != 0) {
        oWebControl.JS_CuttingPartWindow(
          1000 - iCoverRight,
          0,
          iCoverRight,
          600
        );
      }
      if (iCoverBottom != 0) {
        oWebControl.JS_CuttingPartWindow(
          0,
          600 - iCoverBottom,
          1000,
          iCoverBottom
        );
      }
    },
    //播放
    play() {
      let startTime = $("#startTimeStamp").val();
      let endTime = $("#endTimeStamp").val();
      if (!startTime) {
        $("#tipInfo").text("提示：请选择开始时间");
        return;
      }
      if (!endTime) {
        $("#tipInfo").text("提示：请选择结束时间");
        return;
      }
      let sTime = this.timeConversionMillisecond(
        startTime.replace("T", " ") + ":00"
      );
      let eTime = this.timeConversionMillisecond(
        endTime.replace("T", " ") + ":00"
      );
      if (sTime > eTime) {
        $("#tipInfo").text("提示：开始时间不可大于结束时间");
        return;
      }
      if (eTime - sTime > 1 * 24 * 60 * 60 * 1000) {
        $("#tipInfo").text("提示：查询时间段不可大于24小时");
        return;
      }
      // let cameraIndexCode = $('#cameraIndexCode').val() //获取输入的监控点编号值，必填
      let startTimeStamp = new Date(
        $("#startTimeStamp")
          .val()
          .replace("T", " ")
          .replace("-", "/")
          .replace("-", "/")
      ).getTime(); //回放开始时间戳，必填
      let endTimeStamp = new Date(
        $("#endTimeStamp")
          .val()
          .replace("T", " ")
          .replace("-", "/")
          .replace("-", "/")
      ).getTime(); //回放结束时间戳，必填
      let recordLocation = 1; //录像存储位置：0-中心存储，1-设备存储
      let transMode = 1; //传输协议：0-UDP，1-TCP
      let gpuMode = 0; //是否启用GPU硬解，0-不启用，1-启用
      let wndId = -1; //播放窗口序号（在2x2以上布局下可指定播放窗口）
      $("#tipInfo").text("");
      oWebControl.JS_RequestInterface({
        funcName: "startPlayback",
        argument: JSON.stringify({
          cameraIndexCode: this.camreaParams.cameraIndexCode, //监控点编号
          startTimeStamp: Math.floor(startTimeStamp / 1000).toString(), //录像查询开始时间戳，单位：秒
          endTimeStamp: Math.floor(endTimeStamp / 1000).toString(), //录像结束开始时间戳，单位：秒
          recordLocation: recordLocation, //录像存储类型：0-中心存储，1-设备存储
          transMode: transMode, //传输协议：0-UDP，1-TCP
          gpuMode: gpuMode, //是否启用GPU硬解，0-不启用，1-启用
          wndId: wndId, //可指定播放窗口
        }),
      });
    },
    //停止播放
    stop() {
      oWebControl.JS_RequestInterface({
        funcName: "stopAllPlayback",
      });
    },
    timeConversionMillisecond(strTime) {
      return new Date(strTime.replace(new RegExp("-", "gm"), "/")).getTime();
    },
    //关闭视频窗口
    closeWindow() {
      if (oWebControl != null) {
        oWebControl.JS_HideWnd(); // 先让窗口隐藏，规避可能的插件窗口滞后于浏览器消失问题
        oWebControl.JS_Disconnect().then(
          () => {
            // 断开与插件服务连接成功
          },
          () => {
            // 断开与插件服务连接失败
          }
        );
      }
    },
    dateFormat(oDate, fmt) {
      let o = {
        "M+": oDate.getMonth() + 1, //月份
        "d+": oDate.getDate(), //日
        "h+": oDate.getHours(), //小时
        "m+": oDate.getMinutes(), //分
        "s+": oDate.getSeconds(), //秒
        "q+": Math.floor((oDate.getMonth() + 3) / 3), //季度
        S: oDate.getMilliseconds(), //毫秒
      };
      if (/(y+)/.test(fmt)) {
        fmt = fmt.replace(
          RegExp.$1,
          (oDate.getFullYear() + "").substr(4 - RegExp.$1.length)
        );
      }
      for (var k in o) {
        if (new RegExp("(" + k + ")").test(fmt)) {
          fmt = fmt.replace(
            RegExp.$1,
            RegExp.$1.length == 1
              ? o[k]
              : ("00" + o[k]).substr(("" + o[k]).length)
          );
        }
      }
      return fmt;
    },
  },
};
</script>

<style lang="scss" scoped>
#videoReplay {
  .el-row {
    margin-top: 8px;
  }
  .date {
    height: 40px;
    line-height: 40px;
    font-size: 16px;
  }
  .dateLine {
    height: 40px;
    line-height: 40px;
    text-align: center;
  }
  .dateInp {
    width: 46%;
    float: left;
  }
}
.el-input__inner {
  background-color: #fff;
  background-image: none;
  border-radius: 5px;
  border: 1px solid #dcdfe6;
  box-sizing: border-box;
  color: #606266;
  display: inline-block;
  font-size: inherit;
  height: 40px;
  line-height: 40px;
  outline: none;
  padding: 0 8px;
  transition: border-color 0.2s;
}
</style>
